const DEV = {
    baseUrl: "http://localhost:3010/v1/"
};
const PROD = {
    baseUrl: "https://purchasing.kjdelectronics.com/v1/"
};

const config = process.env.NODE_ENV.toLowerCase() === 'production' ? PROD : DEV;

export { config };